import { useEffect } from 'react';
import { motion } from 'framer-motion';

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.1 },
  transition: { duration: 0.5 },
};

const sections = [
  {
    number: '1',
    title: 'Responsable del Tratamiento',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        CrossPay Solutions S.A.S., identificada con NIT 900.648.294-5, con domicilio en Bogotá D.C.,
        actúa como responsable del tratamiento de los datos personales recolectados en el ejercicio
        de sus operaciones.
        Correo de contacto:{' '}
        <a href="mailto:legal@crosspaysolutions.com" className="text-accent-magenta hover:underline">
          legal@crosspaysolutions.com
        </a>
      </p>
    ),
  },
  {
    number: '2',
    title: 'Objeto y Marco Legal',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        Esta política regula el procedimiento para el ejercicio de los derechos de Petición, Queja
        y Reclamo (PQR) en materia de Habeas Data, de conformidad con la Ley 1581 de 2012 y el
        Decreto 1377 de 2013.
      </p>
    ),
  },
  {
    number: '3',
    title: 'Derechos del Titular',
    content: (
      <>
        <p>De conformidad con la Ley 1581 de 2012, el titular de los datos personales tiene derecho a:</p>
        {/* PENDIENTE — insertar texto del PDF */}
        <ul className="list-disc list-inside mt-3 space-y-2">
          <li>Conocer, actualizar y rectificar sus datos personales.</li>
          <li>Solicitar prueba de la autorización otorgada.</li>
          <li>Ser informado sobre el uso que se ha dado a sus datos.</li>
          <li>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC).</li>
          <li>Revocar la autorización y/o solicitar la supresión de sus datos cuando no se respeten los principios legales.</li>
          <li>Acceder de forma gratuita a sus datos personales tratados.</li>
        </ul>
      </>
    ),
  },
  {
    number: '4',
    title: 'Canales para Presentar PQR',
    content: (
      <>
        {/* PENDIENTE — insertar texto del PDF */}
        <p>El titular podrá ejercer sus derechos mediante los siguientes canales:</p>
        <ul className="list-disc list-inside mt-3 space-y-2">
          <li>
            Correo electrónico:{' '}
            <a href="mailto:legal@crosspaysolutions.com" className="text-accent-magenta hover:underline">
              legal@crosspaysolutions.com
            </a>
          </li>
          <li>
            Correo electrónico de soporte:{' '}
            <a href="mailto:soporte@crosspaysolutions.com" className="text-accent-magenta hover:underline">
              soporte@crosspaysolutions.com
            </a>
          </li>
        </ul>
      </>
    ),
  },
  {
    number: '5',
    title: 'Procedimiento para Consultas',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        Las consultas serán atendidas en un término máximo de diez (10) días hábiles contados a
        partir de la fecha de recibo. Cuando no fuere posible atender la consulta dentro de dicho
        término, se informará al interesado, expresando los motivos de la demora y señalando la
        fecha en que se atenderá su consulta, la cual en ningún caso podrá superar los cinco (5)
        días hábiles siguientes al vencimiento del primer término.
      </p>
    ),
  },
  {
    number: '6',
    title: 'Procedimiento para Reclamos',
    content: (
      <>
        {/* PENDIENTE — insertar texto del PDF */}
        <p>
          Si el titular o causahabiente considera que la información contenida en una base de datos
          debe ser objeto de corrección, actualización o supresión, o cuando advierte el presunto
          incumplimiento de la normatividad en materia de protección de datos, el reclamo se tramitará
          bajo las siguientes reglas:
        </p>
        <ul className="list-disc list-inside mt-3 space-y-2">
          <li>El reclamo se formulará mediante solicitud escrita dirigida al responsable con la identificación del titular, descripción de los hechos y documentos de soporte.</li>
          <li>Si el reclamo resulta incompleto, se requerirá al interesado dentro de los cinco (5) días siguientes a la recepción para que subsane las fallas.</li>
          <li>El término máximo para atender el reclamo será de quince (15) días hábiles contados a partir del día siguiente a la fecha de su recibo.</li>
          <li>Cuando no fuere posible atenderlo dentro de dicho término, se informará al interesado los motivos de la demora y la fecha de respuesta, que no podrá superar ocho (8) días hábiles adicionales.</li>
        </ul>
      </>
    ),
  },
  {
    number: '7',
    title: 'Supresión de Datos',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        El titular tiene el derecho a solicitar la supresión (eliminación) de sus datos personales
        cuando considere que no están siendo tratados conforme a los principios, deberes y
        obligaciones previstas en la normatividad vigente. CrossPay Solutions S.A.S. podrá negar la
        supresión cuando el titular tenga el deber legal o contractual de permanecer en la base de
        datos, o cuando la supresión pueda obstaculizar actuaciones judiciales o administrativas.
      </p>
    ),
  },
  {
    number: '8',
    title: 'Transferencia y Transmisión Internacional de Datos',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        Los datos personales podrán ser transferidos o transmitidos a aliados tecnológicos, entidades
        reguladas o autoridades competentes, nacionales o internacionales, únicamente para el
        cumplimiento de los servicios y finalidades descritos en la Política de Privacidad, de
        conformidad con la ley.
      </p>
    ),
  },
  {
    number: '9',
    title: 'Revocatoria de Autorización',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        El titular podrá revocar en cualquier momento la autorización otorgada para el tratamiento
        de sus datos personales, siempre que no exista impedimento legal o contractual. La
        solicitud deberá ser presentada mediante los canales indicados en la sección 4 de este
        documento.
      </p>
    ),
  },
  {
    number: '10',
    title: 'Recurso ante la SIC',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        El titular o causahabiente que no estuviere satisfecho con la respuesta a su PQR podrá
        acudir ante la Superintendencia de Industria y Comercio (SIC), entidad que ejerce la
        vigilancia sobre el tratamiento de datos personales en Colombia.
      </p>
    ),
  },
  {
    number: '11',
    title: 'Vigencia',
    content: (
      <p>
        {/* PENDIENTE — insertar texto del PDF */}
        Esta política rige a partir del 4 de abril de 2026 y podrá ser modificada en cualquier
        momento, sujeto a publicación por los canales oficiales de CrossPay Solutions S.A.S.
      </p>
    ),
  },
];

export default function PqrHabeasDataPage() {
  useEffect(() => {
    document.title = 'PQR Habeas Data | CrossPay Solutions';
  }, []);

  return (
    <main id="main-content">
      {/* Hero */}
      <section className="pt-40 pb-20 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center_top,rgba(168,67,151,0.08),transparent_70%)] pointer-events-none" />
        <div className="mx-auto min-w-0 max-w-4xl px-4 sm:px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black font-headline tracking-tight">
              PQR <span className="gradient-text">Habeas Data</span>
            </h1>
            <p className="text-on-surface-variant text-lg mt-4">
              CrossPay Solutions S.A.S.
            </p>
            <p className="text-on-surface-variant/70 mt-2 text-sm">
              Procedimiento para el ejercicio de derechos sobre datos personales · Ley 1581 de 2012
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content sections */}
      <section className="pb-20">
        <div className="mx-auto min-w-0 max-w-3xl space-y-10 px-4 sm:px-6">
          {sections.map((s, i) => (
            <motion.div
              key={s.number}
              className="p-6 border border-outline-variant/30 rounded-xl hover:border-purple-primary/50 transition-all duration-300"
              {...fadeIn}
              transition={{ delay: i * 0.05, duration: 0.5 }}
            >
              <h2 className="text-xl font-bold font-headline mb-3">
                <span className="gradient-text">{s.number}.</span> {s.title}
              </h2>
              <div className="text-sm text-on-surface-variant leading-relaxed">
                {s.content}
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}
